// extracted by mini-css-extract-plugin
export var fadeIn = "_av-0";